import { FC } from 'react'

const KeyboardArrowDown: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8.482"
      height="5.657"
      viewBox="0 0 8.482 5.657"
    >
      <rect
        id="長方形_2322"
        data-name="長方形 2322"
        width="6"
        height="2"
        rx="1"
        transform="translate(2.825 4.243) rotate(-45)"
        fill="#00a26a"
      />
      <rect
        id="長方形_2323"
        data-name="長方形 2323"
        width="6"
        height="2"
        rx="1"
        transform="translate(1.414) rotate(45)"
        fill="#00a26a"
      />
    </svg>
  )
}

export default KeyboardArrowDown
